/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/containers/admin-business-profiles.component.scss */
.entity-name {
  font-style: italic;
  font-size: 14px;
  padding-left: 16px;
}
.entity-name:hover:not(.entity-name--disabled) {
  cursor: pointer;
  text-decoration: underline;
}
.iot4bos-ui-backoffice-business-profiles-list {
  overflow: auto;
  min-height: 40%;
}
/*# sourceMappingURL=admin-business-profiles.component.css.map */
